<template>
  <v-container fluid class="new-appraisal">
    <div class="new-appraisal-content" v-if="steps">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <template>
            <v-stepper-step
              v-for="n in steps"
              :key="`${n.step}-step`"
              :complete="e1 > n.step"
              :step="n.step"
            >
              <span class="ml-2">{{ n.label }}</span>
              <v-divider v-if="n !== steps" :key="n.step"></v-divider>
            </v-stepper-step>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            v-for="n in steps"
            :key="`${n.step}-content`"
            :step="n.step"
          >
            <div class="content-step1" v-if="n.step == 1">
              <v-text-field
                v-model="step1.name"
                placeholder="Propietario"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="step1.phone"
                placeholder="Telefono"
                type="number"
              ></v-text-field>
              <v-text-field
                v-model="step1.interesado"
                placeholder="V.Interesado"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="step1.entrega"
                placeholder="Entrega inmediata"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="step1.brand"
                placeholder="Marca"
                type="text"
              ></v-text-field>
              <h3>Datos del vehículo</h3>

              <v-text-field
                v-model="step1.model"
                placeholder="Modelo"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.plate"
                placeholder="Matrícula"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.color"
                placeholder="Color"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.kilometers"
                placeholder="Kilómetros"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.engine"
                placeholder="Motor"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.year"
                placeholder="Año"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.itv"
                placeholder="ITV"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.insurance"
                placeholder="Seguro"
                type="text"
              ></v-text-field>

              <v-textarea
                v-model="step1.notes"
                label="Observaciones"
              ></v-textarea>

              <h3>Documentación</h3>
              <v-file-input
                class="mt-5"
                v-model="documentation"
                color="primary"
                counter
                multiple
                placeholder="Documentación del vehículo"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>

                  <span
                    v-else-if="index === 2"
                    class="text-overline grey--text text--darken-3 mx-2"
                  >
                    +{{ documentation.length - 2 }} Archivo(s)
                  </span>
                </template>
              </v-file-input>
            </div>
            <div class="content-step2" v-if="n.step == 2">
              <v-tabs v-model="tab" color="primary" grow>
                <v-tab v-for="item in tabItem" :key="item">
                  {{ item }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in tabItem" :key="item">
                  <v-card flat>
                    <v-row class="manual mt-5" v-if="item == 'Manual'">
                      <v-col cols="12">
                        <div class="mb-5">
                          <h3>Mecánica y Electricidad</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="MOTOR"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_engine"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_engine"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_engine"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="EMBRAGUE"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_clutch"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_clutch"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_clutch"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="CAJA DE CAMBIOS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_gearbox"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_gearbox"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_gearbox"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="DIRECCIÓN"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_direction"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_direction"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_direction"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td colspan="4">
                                  <v-textarea
                                    placeholder="VARIOS"
                                    v-model="step2.mechanics_other"
                                  ></v-textarea>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div class="mt-5">
                          <h3>Interior</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="VOLANTE"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_steering_wheel"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_steering_wheel"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_steering_wheel"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="ASIENTOS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_seating"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_seating"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_seating"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="TECHO"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_roof"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_roof"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_roof"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="ESTADO GENERAL"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_general_status"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_general_status"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_general_status"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>
                      </v-col>
                      <v-col cols="2" class="d-flex justify-center">
                        <v-divider vertical></v-divider>
                      </v-col>
                      <v-col cols="12">
                        <div class="mb-5">
                          <h3>Exterior</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="LATERAL D"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_right"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_right"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_right"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="LATERAL I"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_left"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_left"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_left"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="P.DELANTERA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_front"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_front"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_front"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="P.TRASERA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_back"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_back"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_back"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="PINTURA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_general_paint"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_general_paint"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_general_paint"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="LUNAS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_windows"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_windows"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_windows"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div class="mt-5">
                          <h3>Neumáticos</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="DELANTEROS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_front"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_front"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_front"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="TRASEROS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_back"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_back"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_back"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="LLANTAS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_llantas"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_llantas"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_llantas"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ESTADO GENERAL"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_general_status"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_general_status"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_general_status"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div class="mt-5">
                          <h3>Imágenes</h3>
                          <v-file-input
                            class="mt-5"
                            v-model="images"
                            color="primary"
                            counter
                            multiple
                            placeholder="Imágenes del vehículo"
                            prepend-icon="mdi-paperclip"
                            outlined
                            :show-size="1000"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                v-if="index < 2"
                                color="primary"
                                dark
                                label
                                small
                              >
                                {{ text }}
                              </v-chip>

                              <span
                                v-else-if="index === 2"
                                class="text-overline grey--text text--darken-3 mx-2"
                              >
                                +{{ images.length - 2 }} Archivo(s)
                              </span>
                            </template>
                          </v-file-input>
                        </div>

                        <div class="mt-5">
                          <h3>Galería</h3>
                          <h3 v-if="imagesSelected.length <= 0">
                            No hay imágenes de este vehículo
                          </h3>
                          <div v-else class="d-flex justify-center flex-wrap">
                            <div v-for="img in imagesSelected" :key="img.id">
                              <v-img
                                :src="img.image"
                                :lazy-src="img.image"
                                aspect-ratio="1"
                                max-height="200"
                                max-width="200"
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="grey lighten-5"
                                    ></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </div>
                          </div>
                        </div>

                        <v-btn color="primary" @click="nextStep(n.step)">
                          GUARDAR
                        </v-btn>
                      </v-col>
                    </v-row>
                    <!-- <div class="automatico" v-else>
                      Automatico
                    </div> -->
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </div>

            <v-btn color="primary" @click="nextStep(n.step)">
              GUARDAR
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  postMethodToken,
  postMethodTokenImage,
  postMethodTokenDoc
} from "@/api-consume/api-calls";
import store from "@/store/index";
export default {
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      snackbarTimeout: 3000,
      snackbarColor: "",
      tab: null,
      tabItem: ["Manual"],
      //tabItem: ["Manual", "Automático"],
      e1: 1,
      steps: [
        { label: "Datos no técnicos", step: 1 },
        { label: "Datos técnicos", step: 2 }
      ],
      step1: {
        name: "",
        phone: "",
        interesado: "",
        commercial_user_id: store.state.userLogged.user_id,
        entrega: "",
        brand: "",
        model: "",
        plate: "",
        color: "",
        kilometers: "",
        engine: "",
        year: "",
        itv: "",
        insurance: "",
        notes: ""
      },
      step2: {
        //Mecánica y electricidad
        mechanics_engine: "",
        mechanics_clutch: "",
        mechanics_gearbox: "",
        mechanics_direction: "",
        mechanics_other: "",
        //Interior
        interior_steering_wheel: "",
        interior_seating: "",
        interior_roof: "",
        interior_general_status: "",
        //Exterior
        exterior_lateral_right: "",
        exterior_lateral_left: "",
        exterior_front: "",
        exterior_back: "",
        exterior_general_paint: "",
        exterior_windows: "",
        //Neumáticos
        tires_front: "",
        tires_back: "",
        tires_llantas: "",
        tires_general_status: ""
      },
      images: [],
      responseId: "",
      documentation: []
    };
  },

  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    }
  },

  methods: {
    async nextStep(n) {
      var options = {};
      var flag = true;
      switch (n) {
        case 1:
          //var check = Object.values(this.step1).includes("");
          var findEmpty = Object.entries(this.step1).filter(
            item => item[1] == ""
          );
          console.log("Vacíos", findEmpty);
          if (
            findEmpty.length > 1 ||
            (findEmpty.length == 1 && findEmpty[0][0] != "notes") ||
            this.documentation.length == 0
          ) {
            this.snackbar = true;
            this.snackbarText = "Complete todos los campos.";
            this.snackbarColor = "red";
            flag = false;
          }
          options = this.step1;
          options.step_1 = 1;
          break;
        case 2:
          options = this.step2;
          options.step_2 = 1;
          options.id = this.responseId;
          break;

        default:
          break;
      }

      if (flag) {
        console.log("ENVÍO: ", options);
        const response = await postMethodToken(
          "/api/appraisal/create",
          options
        );
        console.log("CREAR TASACIÓN: ", response);

        if (response.status == 200) {
          this.responseId = response.data.payload.appraisal.id;
          if (n == 1) {
            console.log(
              "ENVÍO documentacion: ",
              this.responseId,
              this.documentation
            );
            for (let x = 0; x < this.documentation.length; x++) {
              const resp = await postMethodTokenDoc(
                "/api/appraisal/docs/upload",
                this.responseId,
                this.documentation[x]
              );
              console.log("SUBIR DOCUMENTACION: ", resp);
              if (resp.status != 200) {
                this.snackbar = true;
                this.snackbarText = "Error al guardar la documentacion.";
                this.snackbarColor = "red";
                return 0;
              }
            }
          }
          if (n == 2) {
            console.log("ENVÍO IMAGES: ", this.responseId, this.images);
            for (let x = 0; x < this.images.length; x++) {
              const resp = await postMethodTokenImage(
                "/api/appraisal/images/upload",
                this.responseId,
                this.images[x]
              );
              console.log("SUBIR IMAGENES: ", resp);
              if (resp.status != 200) {
                this.snackbar = true;
                this.snackbarText = "Error al guardar las imágenes.";
                this.snackbarColor = "red";
                return 0;
              }
            }
          }
          if (n === this.steps.step) {
            this.e1 = 1;
          } else {
            this.e1 = n + 1;
          }
        } else {
          this.snackbar = true;
          this.snackbarText = "Error al crear la tasación.";
          this.snackbarColor = "red";
        }
      }
    }
  }
};
</script>
